import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import { getLocationAttributesForSegment, getRetailerName } from './utils';
import { getOpenStatus } from '../locations/utils/workHours';
import FFLinkButton from '../../buttons/FFLinkButton';
import PinIcon from '../../icons/PinIcon';
import ClockIcon from '../../icons/ClockIcon';
import FridgeLocationTags from '../../tags/FridgeLocationTags';
import useSegment, { EVENTS } from '../../../utils/useSegment';
import styles from './Hero.module.css';

/**
 * @param {object} props
 * @param {FF.Location__LDP} props.locationData
 */
export default function Hero({ locationData }) {
  const { pushTrackEvent } = useSegment();

  const isFridge = locationData.type === 'FRIDGE';
  const isRetail = locationData.type === 'WHOLESALE';

  const openNowStatusMessage =
    isFridge &&
    locationData.locationConfigs.workHours &&
    locationData.locationConfigs.timeZone
      ? getOpenStatus(
          JSON.parse(locationData.locationConfigs.workHours),
          locationData.locationConfigs.timeZone,
        )?.message
      : null;

  const retailerName = getRetailerName(locationData);

  let wrapperClass = 'wrapper';
  if (isFridge) {
    wrapperClass = 'fridgeWrapper';
  } else if (isRetail) {
    wrapperClass = 'retailWrapper';
  }

  return (
    <div className={styles[wrapperClass]}>
      {isFridge && (
        <StaticImage
          alt="Photo of a Farmer's Fridge Kiosk"
          className={styles.heroBg}
          imgClassName={styles.heroImage}
          layout="fullWidth"
          loading="eager"
          src="../../../assets/img/LDP_Fridge_Hero.jpg"
        />
      )}
      {isRetail && (
        <StaticImage
          alt="Photo of Farmer's Fridge products in a retailer's cooler"
          className={styles.heroBg}
          imgClassName={styles.heroImage}
          layout="fullWidth"
          loading="eager"
          src="../../../assets/img/LDP_Retail_Hero.jpg"
        />
      )}
      <div className={styles.overlay}>
        <div className={styles.overlayInnerWrapper}>
          {retailerName && <div>{retailerName}</div>}
          {isFridge && (
            <FridgeLocationTags
              className={styles.tag}
              location={locationData}
            />
          )}
          <h1 className={styles.header1Normal}>
            {locationData.locationConfigs.prettyName}
          </h1>
          <div className={styles.lineItem}>
            <PinIcon className={styles.lineItemIcon} />
            <span className={styles.subtitle1}>
              {locationData.operationConfigs.directions}
            </span>
          </div>
          {isFridge && openNowStatusMessage && (
            <div className={styles.lineItem}>
              <ClockIcon className={styles.lineItemIcon} />
              <span className={styles.subtitle1}>{openNowStatusMessage}</span>
            </div>
          )}
          {isFridge && (
            <FFLinkButton
              className={styles.viewMenuBtn}
              onClick={() => {
                pushTrackEvent(
                  EVENTS.VIEW_MENU,
                  getLocationAttributesForSegment(locationData),
                );
              }}
              buttonType="primary"
              href={locationData.fridgeSpecificMenuPagePath}
            >
              View Menu
            </FFLinkButton>
          )}
        </div>
      </div>
    </div>
  );
}
